// @ vendors
const React = require('react');
const PropTypes = require('prop-types');
// @ utilities
const { FormattedText, formatText } = require('core/i18n').i18n;
// @ commonst
const WizardError = require('components/commons/wizardError/wizardError');

const LoanPartialAmortizationError = ({ accountError }) => {
    const errorMessage = formatText('loanPartialAmortizationError-title');
    const goBackButtonLabel = formatText('loanPartialAmortizationError-backToLoans');
    const linkToLoan = '/myprofile/loans-mortgages';

    const message = accountError ? 'loanPartialAmortizationError-errorAccount' : 'loanPartialAmortizationError-errorMessage';

    const mainButton = {
        label: goBackButtonLabel,
        url: linkToLoan
    }

    return (
        <div className="row no-gutter">
            <div className="col-xs-offset-2 col-xs-8">
                <WizardError
                    errorMessage={errorMessage}
                    mainButton={mainButton}
                >
                    <FormattedText value={message} />
                </WizardError>
            </div>
        </div>
    );
};

LoanPartialAmortizationError.propTypes = {
    accountError: PropTypes.bool
};

module.exports = LoanPartialAmortizationError;
